import { PricingService } from './PricingService';

export default PricingService;